import script from "./RouteSelect.vue?vue&type=script&setup=true&lang=js"
export * from "./RouteSelect.vue?vue&type=script&setup=true&lang=js"

import "./RouteSelect.vue?vue&type=style&index=0&id=04b6bebc&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-04b6bebc"]])

export default __exports__